import { useAuthStore } from '@/stores/authStore'
import { useTimerStore, formatTimerDisplay } from '@/stores/timerStore'
import { NotificationBanner } from '@/components/Dashboard/NotificationBanner'
import { PriorityTaskList } from '@/components/Dashboard/PriorityTaskList'
import { ProactiveCard } from '@/components/AgentActivity/ProactiveCard'
import { useProactiveCards } from '@/hooks/useProactiveCards'
import { Clock } from 'lucide-react'

function getGreeting(): string {
  const hour = new Date().getHours()
  if (hour < 12) return 'Good morning'
  if (hour < 17) return 'Good afternoon'
  return 'Good evening'
}

export function FocusDashboard() {
  const { user } = useAuthStore()
  const { isRunning, taskTitle, elapsedSeconds } = useTimerStore()
  const { suggestions, dismiss } = useProactiveCards()

  const firstName = user?.name?.split(' ')[0] || 'there'
  const isMember = user?.role === 'member'

  return (
    <div className="space-y-4">
      {/* Notification banner — members only */}
      {isMember && <NotificationBanner />}

      {/* Proactive agent suggestions — compact, max 2 in focus mode */}
      {suggestions.slice(0, 2).map((s) => (
        <ProactiveCard key={s.id} suggestion={s} onDismiss={dismiss} />
      ))}

      {/* Compact greeting */}
      <div>
        <h1 className="text-lg font-semibold tracking-tight">
          {getGreeting()}, {firstName}
        </h1>
        <p className="text-sm text-muted-foreground">Focus Mode</p>
      </div>

      {/* Active timer (compact inline) */}
      {isRunning && (
        <div className="flex items-center gap-2 px-3 py-2 bg-primary/10 rounded-lg border border-primary/20">
          <Clock className="h-4 w-4 text-primary" />
          <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          <span className="font-mono text-sm text-primary">
            {formatTimerDisplay(elapsedSeconds)}
          </span>
          <span className="text-sm text-muted-foreground truncate">
            {taskTitle}
          </span>
        </div>
      )}

      {/* Priority tasks */}
      <PriorityTaskList />
    </div>
  )
}
